import { useQueryClient as Pe, useMutation as Z, useQuery as lt } from "@tanstack/react-query";
import { jsx as g, jsxs as T, Fragment as qt } from "react/jsx-runtime";
import { createContext as kt, useMemo as ve, useContext as $t, useState as jt, useRef as He, useEffect as Ve, useCallback as ce } from "react";
import { Badge as Mt, Box as C, Typography as E, formatCurrencyByCode as M, Separator as ue } from "@lucid/lego";
function ut(e, t) {
  return function() {
    return e.apply(t, arguments);
  };
}
const { toString: zt } = Object.prototype, { getPrototypeOf: De } = Object, { iterator: me, toStringTag: dt } = Symbol, ye = /* @__PURE__ */ ((e) => (t) => {
  const n = zt.call(t);
  return e[n] || (e[n] = n.slice(8, -1).toLowerCase());
})(/* @__PURE__ */ Object.create(null)), B = (e) => (e = e.toLowerCase(), (t) => ye(t) === e), be = (e) => (t) => typeof t === e, { isArray: Q } = Array, X = be("undefined");
function ee(e) {
  return e !== null && !X(e) && e.constructor !== null && !X(e.constructor) && P(e.constructor.isBuffer) && e.constructor.isBuffer(e);
}
const ft = B("ArrayBuffer");
function It(e) {
  let t;
  return typeof ArrayBuffer < "u" && ArrayBuffer.isView ? t = ArrayBuffer.isView(e) : t = e && e.buffer && ft(e.buffer), t;
}
const vt = be("string"), P = be("function"), pt = be("number"), te = (e) => e !== null && typeof e == "object", Ht = (e) => e === !0 || e === !1, de = (e) => {
  if (ye(e) !== "object")
    return !1;
  const t = De(e);
  return (t === null || t === Object.prototype || Object.getPrototypeOf(t) === null) && !(dt in e) && !(me in e);
}, Vt = (e) => {
  if (!te(e) || ee(e))
    return !1;
  try {
    return Object.keys(e).length === 0 && Object.getPrototypeOf(e) === Object.prototype;
  } catch {
    return !1;
  }
}, Kt = B("Date"), Jt = B("File"), Wt = (e) => !!(e && typeof e.uri < "u"), Xt = (e) => e && typeof e.getParts < "u", Qt = B("Blob"), Gt = B("FileList"), Yt = (e) => te(e) && P(e.pipe);
function Zt() {
  return typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : typeof global < "u" ? global : {};
}
const Ke = Zt(), Je = typeof Ke.FormData < "u" ? Ke.FormData : void 0, en = (e) => {
  let t;
  return e && (Je && e instanceof Je || P(e.append) && ((t = ye(e)) === "formdata" || // detect form-data instance
  t === "object" && P(e.toString) && e.toString() === "[object FormData]"));
}, tn = B("URLSearchParams"), [nn, rn, sn, on] = [
  "ReadableStream",
  "Request",
  "Response",
  "Headers"
].map(B), an = (e) => e.trim ? e.trim() : e.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
function ne(e, t, { allOwnKeys: n = !1 } = {}) {
  if (e === null || typeof e > "u")
    return;
  let r, s;
  if (typeof e != "object" && (e = [e]), Q(e))
    for (r = 0, s = e.length; r < s; r++)
      t.call(null, e[r], r, e);
  else {
    if (ee(e))
      return;
    const o = n ? Object.getOwnPropertyNames(e) : Object.keys(e), i = o.length;
    let c;
    for (r = 0; r < i; r++)
      c = o[r], t.call(null, e[c], c, e);
  }
}
function ht(e, t) {
  if (ee(e))
    return null;
  t = t.toLowerCase();
  const n = Object.keys(e);
  let r = n.length, s;
  for (; r-- > 0; )
    if (s = n[r], t === s.toLowerCase())
      return s;
  return null;
}
const H = typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : global, mt = (e) => !X(e) && e !== H;
function Te() {
  const { caseless: e, skipUndefined: t } = mt(this) && this || {}, n = {}, r = (s, o) => {
    if (o === "__proto__" || o === "constructor" || o === "prototype")
      return;
    const i = e && ht(n, o) || o;
    de(n[i]) && de(s) ? n[i] = Te(n[i], s) : de(s) ? n[i] = Te({}, s) : Q(s) ? n[i] = s.slice() : (!t || !X(s)) && (n[i] = s);
  };
  for (let s = 0, o = arguments.length; s < o; s++)
    arguments[s] && ne(arguments[s], r);
  return n;
}
const cn = (e, t, n, { allOwnKeys: r } = {}) => (ne(
  t,
  (s, o) => {
    n && P(s) ? Object.defineProperty(e, o, {
      value: ut(s, n),
      writable: !0,
      enumerable: !0,
      configurable: !0
    }) : Object.defineProperty(e, o, {
      value: s,
      writable: !0,
      enumerable: !0,
      configurable: !0
    });
  },
  { allOwnKeys: r }
), e), ln = (e) => (e.charCodeAt(0) === 65279 && (e = e.slice(1)), e), un = (e, t, n, r) => {
  e.prototype = Object.create(t.prototype, r), Object.defineProperty(e.prototype, "constructor", {
    value: e,
    writable: !0,
    enumerable: !1,
    configurable: !0
  }), Object.defineProperty(e, "super", {
    value: t.prototype
  }), n && Object.assign(e.prototype, n);
}, dn = (e, t, n, r) => {
  let s, o, i;
  const c = {};
  if (t = t || {}, e == null) return t;
  do {
    for (s = Object.getOwnPropertyNames(e), o = s.length; o-- > 0; )
      i = s[o], (!r || r(i, e, t)) && !c[i] && (t[i] = e[i], c[i] = !0);
    e = n !== !1 && De(e);
  } while (e && (!n || n(e, t)) && e !== Object.prototype);
  return t;
}, fn = (e, t, n) => {
  e = String(e), (n === void 0 || n > e.length) && (n = e.length), n -= t.length;
  const r = e.indexOf(t, n);
  return r !== -1 && r === n;
}, pn = (e) => {
  if (!e) return null;
  if (Q(e)) return e;
  let t = e.length;
  if (!pt(t)) return null;
  const n = new Array(t);
  for (; t-- > 0; )
    n[t] = e[t];
  return n;
}, hn = /* @__PURE__ */ ((e) => (t) => e && t instanceof e)(typeof Uint8Array < "u" && De(Uint8Array)), mn = (e, t) => {
  const r = (e && e[me]).call(e);
  let s;
  for (; (s = r.next()) && !s.done; ) {
    const o = s.value;
    t.call(e, o[0], o[1]);
  }
}, yn = (e, t) => {
  let n;
  const r = [];
  for (; (n = e.exec(t)) !== null; )
    r.push(n);
  return r;
}, bn = B("HTMLFormElement"), gn = (e) => e.toLowerCase().replace(/[-_\s]([a-z\d])(\w*)/g, function(n, r, s) {
  return r.toUpperCase() + s;
}), We = (({ hasOwnProperty: e }) => (t, n) => e.call(t, n))(Object.prototype), wn = B("RegExp"), yt = (e, t) => {
  const n = Object.getOwnPropertyDescriptors(e), r = {};
  ne(n, (s, o) => {
    let i;
    (i = t(s, o, e)) !== !1 && (r[o] = i || s);
  }), Object.defineProperties(e, r);
}, Rn = (e) => {
  yt(e, (t, n) => {
    if (P(e) && ["arguments", "caller", "callee"].indexOf(n) !== -1)
      return !1;
    const r = e[n];
    if (P(r)) {
      if (t.enumerable = !1, "writable" in t) {
        t.writable = !1;
        return;
      }
      t.set || (t.set = () => {
        throw Error("Can not rewrite read-only method '" + n + "'");
      });
    }
  });
}, En = (e, t) => {
  const n = {}, r = (s) => {
    s.forEach((o) => {
      n[o] = !0;
    });
  };
  return Q(e) ? r(e) : r(String(e).split(t)), n;
}, Sn = () => {
}, An = (e, t) => e != null && Number.isFinite(e = +e) ? e : t;
function On(e) {
  return !!(e && P(e.append) && e[dt] === "FormData" && e[me]);
}
const Cn = (e) => {
  const t = new Array(10), n = (r, s) => {
    if (te(r)) {
      if (t.indexOf(r) >= 0)
        return;
      if (ee(r))
        return r;
      if (!("toJSON" in r)) {
        t[s] = r;
        const o = Q(r) ? [] : {};
        return ne(r, (i, c) => {
          const f = n(i, s + 1);
          !X(f) && (o[c] = f);
        }), t[s] = void 0, o;
      }
    }
    return r;
  };
  return n(e, 0);
}, Tn = B("AsyncFunction"), _n = (e) => e && (te(e) || P(e)) && P(e.then) && P(e.catch), bt = ((e, t) => e ? setImmediate : t ? ((n, r) => (H.addEventListener(
  "message",
  ({ source: s, data: o }) => {
    s === H && o === n && r.length && r.shift()();
  },
  !1
), (s) => {
  r.push(s), H.postMessage(n, "*");
}))(`axios@${Math.random()}`, []) : (n) => setTimeout(n))(typeof setImmediate == "function", P(H.postMessage)), Nn = typeof queueMicrotask < "u" ? queueMicrotask.bind(H) : typeof process < "u" && process.nextTick || bt, xn = (e) => e != null && P(e[me]), a = {
  isArray: Q,
  isArrayBuffer: ft,
  isBuffer: ee,
  isFormData: en,
  isArrayBufferView: It,
  isString: vt,
  isNumber: pt,
  isBoolean: Ht,
  isObject: te,
  isPlainObject: de,
  isEmptyObject: Vt,
  isReadableStream: nn,
  isRequest: rn,
  isResponse: sn,
  isHeaders: on,
  isUndefined: X,
  isDate: Kt,
  isFile: Jt,
  isReactNativeBlob: Wt,
  isReactNative: Xt,
  isBlob: Qt,
  isRegExp: wn,
  isFunction: P,
  isStream: Yt,
  isURLSearchParams: tn,
  isTypedArray: hn,
  isFileList: Gt,
  forEach: ne,
  merge: Te,
  extend: cn,
  trim: an,
  stripBOM: ln,
  inherits: un,
  toFlatObject: dn,
  kindOf: ye,
  kindOfTest: B,
  endsWith: fn,
  toArray: pn,
  forEachEntry: mn,
  matchAll: yn,
  isHTMLForm: bn,
  hasOwnProperty: We,
  hasOwnProp: We,
  // an alias to avoid ESLint no-prototype-builtins detection
  reduceDescriptors: yt,
  freezeMethods: Rn,
  toObjectSet: En,
  toCamelCase: gn,
  noop: Sn,
  toFiniteNumber: An,
  findKey: ht,
  global: H,
  isContextDefined: mt,
  isSpecCompliantForm: On,
  toJSONObject: Cn,
  isAsyncFn: Tn,
  isThenable: _n,
  setImmediate: bt,
  asap: Nn,
  isIterable: xn
};
let y = class gt extends Error {
  static from(t, n, r, s, o, i) {
    const c = new gt(t.message, n || t.code, r, s, o);
    return c.cause = t, c.name = t.name, t.status != null && c.status == null && (c.status = t.status), i && Object.assign(c, i), c;
  }
  /**
   * Create an Error with the specified message, config, error code, request and response.
   *
   * @param {string} message The error message.
   * @param {string} [code] The error code (for example, 'ECONNABORTED').
   * @param {Object} [config] The config.
   * @param {Object} [request] The request.
   * @param {Object} [response] The response.
   *
   * @returns {Error} The created error.
   */
  constructor(t, n, r, s, o) {
    super(t), Object.defineProperty(this, "message", {
      value: t,
      enumerable: !0,
      writable: !0,
      configurable: !0
    }), this.name = "AxiosError", this.isAxiosError = !0, n && (this.code = n), r && (this.config = r), s && (this.request = s), o && (this.response = o, this.status = o.status);
  }
  toJSON() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: a.toJSONObject(this.config),
      code: this.code,
      status: this.status
    };
  }
};
y.ERR_BAD_OPTION_VALUE = "ERR_BAD_OPTION_VALUE";
y.ERR_BAD_OPTION = "ERR_BAD_OPTION";
y.ECONNABORTED = "ECONNABORTED";
y.ETIMEDOUT = "ETIMEDOUT";
y.ERR_NETWORK = "ERR_NETWORK";
y.ERR_FR_TOO_MANY_REDIRECTS = "ERR_FR_TOO_MANY_REDIRECTS";
y.ERR_DEPRECATED = "ERR_DEPRECATED";
y.ERR_BAD_RESPONSE = "ERR_BAD_RESPONSE";
y.ERR_BAD_REQUEST = "ERR_BAD_REQUEST";
y.ERR_CANCELED = "ERR_CANCELED";
y.ERR_NOT_SUPPORT = "ERR_NOT_SUPPORT";
y.ERR_INVALID_URL = "ERR_INVALID_URL";
const Pn = null;
function _e(e) {
  return a.isPlainObject(e) || a.isArray(e);
}
function wt(e) {
  return a.endsWith(e, "[]") ? e.slice(0, -2) : e;
}
function Se(e, t, n) {
  return e ? e.concat(t).map(function(s, o) {
    return s = wt(s), !n && o ? "[" + s + "]" : s;
  }).join(n ? "." : "") : t;
}
function Dn(e) {
  return a.isArray(e) && !e.some(_e);
}
const Ln = a.toFlatObject(a, {}, null, function(t) {
  return /^is[A-Z]/.test(t);
});
function ge(e, t, n) {
  if (!a.isObject(e))
    throw new TypeError("target must be an object");
  t = t || new FormData(), n = a.toFlatObject(
    n,
    {
      metaTokens: !0,
      dots: !1,
      indexes: !1
    },
    !1,
    function(m, h) {
      return !a.isUndefined(h[m]);
    }
  );
  const r = n.metaTokens, s = n.visitor || l, o = n.dots, i = n.indexes, f = (n.Blob || typeof Blob < "u" && Blob) && a.isSpecCompliantForm(t);
  if (!a.isFunction(s))
    throw new TypeError("visitor must be a function");
  function d(u) {
    if (u === null) return "";
    if (a.isDate(u))
      return u.toISOString();
    if (a.isBoolean(u))
      return u.toString();
    if (!f && a.isBlob(u))
      throw new y("Blob is not supported. Use a Buffer instead.");
    return a.isArrayBuffer(u) || a.isTypedArray(u) ? f && typeof Blob == "function" ? new Blob([u]) : Buffer.from(u) : u;
  }
  function l(u, m, h) {
    let w = u;
    if (a.isReactNative(t) && a.isReactNativeBlob(u))
      return t.append(Se(h, m, o), d(u)), !1;
    if (u && !h && typeof u == "object") {
      if (a.endsWith(m, "{}"))
        m = r ? m : m.slice(0, -2), u = JSON.stringify(u);
      else if (a.isArray(u) && Dn(u) || (a.isFileList(u) || a.endsWith(m, "[]")) && (w = a.toArray(u)))
        return m = wt(m), w.forEach(function(O, N) {
          !(a.isUndefined(O) || O === null) && t.append(
            // eslint-disable-next-line no-nested-ternary
            i === !0 ? Se([m], N, o) : i === null ? m : m + "[]",
            d(O)
          );
        }), !1;
    }
    return _e(u) ? !0 : (t.append(Se(h, m, o), d(u)), !1);
  }
  const p = [], b = Object.assign(Ln, {
    defaultVisitor: l,
    convertValue: d,
    isVisitable: _e
  });
  function R(u, m) {
    if (!a.isUndefined(u)) {
      if (p.indexOf(u) !== -1)
        throw Error("Circular reference detected in " + m.join("."));
      p.push(u), a.forEach(u, function(w, A) {
        (!(a.isUndefined(w) || w === null) && s.call(t, w, a.isString(A) ? A.trim() : A, m, b)) === !0 && R(w, m ? m.concat(A) : [A]);
      }), p.pop();
    }
  }
  if (!a.isObject(e))
    throw new TypeError("data must be an object");
  return R(e), t;
}
function Xe(e) {
  const t = {
    "!": "%21",
    "'": "%27",
    "(": "%28",
    ")": "%29",
    "~": "%7E",
    "%20": "+",
    "%00": "\0"
  };
  return encodeURIComponent(e).replace(/[!'()~]|%20|%00/g, function(r) {
    return t[r];
  });
}
function Le(e, t) {
  this._pairs = [], e && ge(e, this, t);
}
const Rt = Le.prototype;
Rt.append = function(t, n) {
  this._pairs.push([t, n]);
};
Rt.toString = function(t) {
  const n = t ? function(r) {
    return t.call(this, r, Xe);
  } : Xe;
  return this._pairs.map(function(s) {
    return n(s[0]) + "=" + n(s[1]);
  }, "").join("&");
};
function Un(e) {
  return encodeURIComponent(e).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+");
}
function Et(e, t, n) {
  if (!t)
    return e;
  const r = n && n.encode || Un, s = a.isFunction(n) ? {
    serialize: n
  } : n, o = s && s.serialize;
  let i;
  if (o ? i = o(t, s) : i = a.isURLSearchParams(t) ? t.toString() : new Le(t, s).toString(r), i) {
    const c = e.indexOf("#");
    c !== -1 && (e = e.slice(0, c)), e += (e.indexOf("?") === -1 ? "?" : "&") + i;
  }
  return e;
}
class Qe {
  constructor() {
    this.handlers = [];
  }
  /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   * @param {Object} options The options for the interceptor, synchronous and runWhen
   *
   * @return {Number} An ID used to remove interceptor later
   */
  use(t, n, r) {
    return this.handlers.push({
      fulfilled: t,
      rejected: n,
      synchronous: r ? r.synchronous : !1,
      runWhen: r ? r.runWhen : null
    }), this.handlers.length - 1;
  }
  /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {void}
   */
  eject(t) {
    this.handlers[t] && (this.handlers[t] = null);
  }
  /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */
  clear() {
    this.handlers && (this.handlers = []);
  }
  /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */
  forEach(t) {
    a.forEach(this.handlers, function(r) {
      r !== null && t(r);
    });
  }
}
const Ue = {
  silentJSONParsing: !0,
  forcedJSONParsing: !0,
  clarifyTimeoutError: !1,
  legacyInterceptorReqResOrdering: !0
}, Fn = typeof URLSearchParams < "u" ? URLSearchParams : Le, Bn = typeof FormData < "u" ? FormData : null, qn = typeof Blob < "u" ? Blob : null, kn = {
  isBrowser: !0,
  classes: {
    URLSearchParams: Fn,
    FormData: Bn,
    Blob: qn
  },
  protocols: ["http", "https", "file", "blob", "url", "data"]
}, Fe = typeof window < "u" && typeof document < "u", Ne = typeof navigator == "object" && navigator || void 0, $n = Fe && (!Ne || ["ReactNative", "NativeScript", "NS"].indexOf(Ne.product) < 0), jn = typeof WorkerGlobalScope < "u" && // eslint-disable-next-line no-undef
self instanceof WorkerGlobalScope && typeof self.importScripts == "function", Mn = Fe && window.location.href || "http://localhost", zn = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  hasBrowserEnv: Fe,
  hasStandardBrowserEnv: $n,
  hasStandardBrowserWebWorkerEnv: jn,
  navigator: Ne,
  origin: Mn
}, Symbol.toStringTag, { value: "Module" })), _ = {
  ...zn,
  ...kn
};
function In(e, t) {
  return ge(e, new _.classes.URLSearchParams(), {
    visitor: function(n, r, s, o) {
      return _.isNode && a.isBuffer(n) ? (this.append(r, n.toString("base64")), !1) : o.defaultVisitor.apply(this, arguments);
    },
    ...t
  });
}
function vn(e) {
  return a.matchAll(/\w+|\[(\w*)]/g, e).map((t) => t[0] === "[]" ? "" : t[1] || t[0]);
}
function Hn(e) {
  const t = {}, n = Object.keys(e);
  let r;
  const s = n.length;
  let o;
  for (r = 0; r < s; r++)
    o = n[r], t[o] = e[o];
  return t;
}
function St(e) {
  function t(n, r, s, o) {
    let i = n[o++];
    if (i === "__proto__") return !0;
    const c = Number.isFinite(+i), f = o >= n.length;
    return i = !i && a.isArray(s) ? s.length : i, f ? (a.hasOwnProp(s, i) ? s[i] = [s[i], r] : s[i] = r, !c) : ((!s[i] || !a.isObject(s[i])) && (s[i] = []), t(n, r, s[i], o) && a.isArray(s[i]) && (s[i] = Hn(s[i])), !c);
  }
  if (a.isFormData(e) && a.isFunction(e.entries)) {
    const n = {};
    return a.forEachEntry(e, (r, s) => {
      t(vn(r), s, n, 0);
    }), n;
  }
  return null;
}
function Vn(e, t, n) {
  if (a.isString(e))
    try {
      return (t || JSON.parse)(e), a.trim(e);
    } catch (r) {
      if (r.name !== "SyntaxError")
        throw r;
    }
  return (n || JSON.stringify)(e);
}
const re = {
  transitional: Ue,
  adapter: ["xhr", "http", "fetch"],
  transformRequest: [
    function(t, n) {
      const r = n.getContentType() || "", s = r.indexOf("application/json") > -1, o = a.isObject(t);
      if (o && a.isHTMLForm(t) && (t = new FormData(t)), a.isFormData(t))
        return s ? JSON.stringify(St(t)) : t;
      if (a.isArrayBuffer(t) || a.isBuffer(t) || a.isStream(t) || a.isFile(t) || a.isBlob(t) || a.isReadableStream(t))
        return t;
      if (a.isArrayBufferView(t))
        return t.buffer;
      if (a.isURLSearchParams(t))
        return n.setContentType("application/x-www-form-urlencoded;charset=utf-8", !1), t.toString();
      let c;
      if (o) {
        if (r.indexOf("application/x-www-form-urlencoded") > -1)
          return In(t, this.formSerializer).toString();
        if ((c = a.isFileList(t)) || r.indexOf("multipart/form-data") > -1) {
          const f = this.env && this.env.FormData;
          return ge(
            c ? { "files[]": t } : t,
            f && new f(),
            this.formSerializer
          );
        }
      }
      return o || s ? (n.setContentType("application/json", !1), Vn(t)) : t;
    }
  ],
  transformResponse: [
    function(t) {
      const n = this.transitional || re.transitional, r = n && n.forcedJSONParsing, s = this.responseType === "json";
      if (a.isResponse(t) || a.isReadableStream(t))
        return t;
      if (t && a.isString(t) && (r && !this.responseType || s)) {
        const i = !(n && n.silentJSONParsing) && s;
        try {
          return JSON.parse(t, this.parseReviver);
        } catch (c) {
          if (i)
            throw c.name === "SyntaxError" ? y.from(c, y.ERR_BAD_RESPONSE, this, null, this.response) : c;
        }
      }
      return t;
    }
  ],
  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,
  xsrfCookieName: "XSRF-TOKEN",
  xsrfHeaderName: "X-XSRF-TOKEN",
  maxContentLength: -1,
  maxBodyLength: -1,
  env: {
    FormData: _.classes.FormData,
    Blob: _.classes.Blob
  },
  validateStatus: function(t) {
    return t >= 200 && t < 300;
  },
  headers: {
    common: {
      Accept: "application/json, text/plain, */*",
      "Content-Type": void 0
    }
  }
};
a.forEach(["delete", "get", "head", "post", "put", "patch"], (e) => {
  re.headers[e] = {};
});
const Kn = a.toObjectSet([
  "age",
  "authorization",
  "content-length",
  "content-type",
  "etag",
  "expires",
  "from",
  "host",
  "if-modified-since",
  "if-unmodified-since",
  "last-modified",
  "location",
  "max-forwards",
  "proxy-authorization",
  "referer",
  "retry-after",
  "user-agent"
]), Jn = (e) => {
  const t = {};
  let n, r, s;
  return e && e.split(`
`).forEach(function(i) {
    s = i.indexOf(":"), n = i.substring(0, s).trim().toLowerCase(), r = i.substring(s + 1).trim(), !(!n || t[n] && Kn[n]) && (n === "set-cookie" ? t[n] ? t[n].push(r) : t[n] = [r] : t[n] = t[n] ? t[n] + ", " + r : r);
  }), t;
}, Ge = Symbol("internals"), Wn = (e) => !/[\r\n]/.test(e);
function At(e, t) {
  if (!(e === !1 || e == null)) {
    if (a.isArray(e)) {
      e.forEach((n) => At(n, t));
      return;
    }
    if (!Wn(String(e)))
      throw new Error(`Invalid character in header content ["${t}"]`);
  }
}
function Y(e) {
  return e && String(e).trim().toLowerCase();
}
function Xn(e) {
  let t = e.length;
  for (; t > 0; ) {
    const n = e.charCodeAt(t - 1);
    if (n !== 10 && n !== 13)
      break;
    t -= 1;
  }
  return t === e.length ? e : e.slice(0, t);
}
function fe(e) {
  return e === !1 || e == null ? e : a.isArray(e) ? e.map(fe) : Xn(String(e));
}
function Qn(e) {
  const t = /* @__PURE__ */ Object.create(null), n = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
  let r;
  for (; r = n.exec(e); )
    t[r[1]] = r[2];
  return t;
}
const Gn = (e) => /^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(e.trim());
function Ae(e, t, n, r, s) {
  if (a.isFunction(r))
    return r.call(this, t, n);
  if (s && (t = n), !!a.isString(t)) {
    if (a.isString(r))
      return t.indexOf(r) !== -1;
    if (a.isRegExp(r))
      return r.test(t);
  }
}
function Yn(e) {
  return e.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (t, n, r) => n.toUpperCase() + r);
}
function Zn(e, t) {
  const n = a.toCamelCase(" " + t);
  ["get", "set", "has"].forEach((r) => {
    Object.defineProperty(e, r + n, {
      value: function(s, o, i) {
        return this[r].call(this, t, s, o, i);
      },
      configurable: !0
    });
  });
}
let D = class {
  constructor(t) {
    t && this.set(t);
  }
  set(t, n, r) {
    const s = this;
    function o(c, f, d) {
      const l = Y(f);
      if (!l)
        throw new Error("header name must be a non-empty string");
      const p = a.findKey(s, l);
      (!p || s[p] === void 0 || d === !0 || d === void 0 && s[p] !== !1) && (At(c, f), s[p || f] = fe(c));
    }
    const i = (c, f) => a.forEach(c, (d, l) => o(d, l, f));
    if (a.isPlainObject(t) || t instanceof this.constructor)
      i(t, n);
    else if (a.isString(t) && (t = t.trim()) && !Gn(t))
      i(Jn(t), n);
    else if (a.isObject(t) && a.isIterable(t)) {
      let c = {}, f, d;
      for (const l of t) {
        if (!a.isArray(l))
          throw TypeError("Object iterator must return a key-value pair");
        c[d = l[0]] = (f = c[d]) ? a.isArray(f) ? [...f, l[1]] : [f, l[1]] : l[1];
      }
      i(c, n);
    } else
      t != null && o(n, t, r);
    return this;
  }
  get(t, n) {
    if (t = Y(t), t) {
      const r = a.findKey(this, t);
      if (r) {
        const s = this[r];
        if (!n)
          return s;
        if (n === !0)
          return Qn(s);
        if (a.isFunction(n))
          return n.call(this, s, r);
        if (a.isRegExp(n))
          return n.exec(s);
        throw new TypeError("parser must be boolean|regexp|function");
      }
    }
  }
  has(t, n) {
    if (t = Y(t), t) {
      const r = a.findKey(this, t);
      return !!(r && this[r] !== void 0 && (!n || Ae(this, this[r], r, n)));
    }
    return !1;
  }
  delete(t, n) {
    const r = this;
    let s = !1;
    function o(i) {
      if (i = Y(i), i) {
        const c = a.findKey(r, i);
        c && (!n || Ae(r, r[c], c, n)) && (delete r[c], s = !0);
      }
    }
    return a.isArray(t) ? t.forEach(o) : o(t), s;
  }
  clear(t) {
    const n = Object.keys(this);
    let r = n.length, s = !1;
    for (; r--; ) {
      const o = n[r];
      (!t || Ae(this, this[o], o, t, !0)) && (delete this[o], s = !0);
    }
    return s;
  }
  normalize(t) {
    const n = this, r = {};
    return a.forEach(this, (s, o) => {
      const i = a.findKey(r, o);
      if (i) {
        n[i] = fe(s), delete n[o];
        return;
      }
      const c = t ? Yn(o) : String(o).trim();
      c !== o && delete n[o], n[c] = fe(s), r[c] = !0;
    }), this;
  }
  concat(...t) {
    return this.constructor.concat(this, ...t);
  }
  toJSON(t) {
    const n = /* @__PURE__ */ Object.create(null);
    return a.forEach(this, (r, s) => {
      r != null && r !== !1 && (n[s] = t && a.isArray(r) ? r.join(", ") : r);
    }), n;
  }
  [Symbol.iterator]() {
    return Object.entries(this.toJSON())[Symbol.iterator]();
  }
  toString() {
    return Object.entries(this.toJSON()).map(([t, n]) => t + ": " + n).join(`
`);
  }
  getSetCookie() {
    return this.get("set-cookie") || [];
  }
  get [Symbol.toStringTag]() {
    return "AxiosHeaders";
  }
  static from(t) {
    return t instanceof this ? t : new this(t);
  }
  static concat(t, ...n) {
    const r = new this(t);
    return n.forEach((s) => r.set(s)), r;
  }
  static accessor(t) {
    const r = (this[Ge] = this[Ge] = {
      accessors: {}
    }).accessors, s = this.prototype;
    function o(i) {
      const c = Y(i);
      r[c] || (Zn(s, i), r[c] = !0);
    }
    return a.isArray(t) ? t.forEach(o) : o(t), this;
  }
};
D.accessor([
  "Content-Type",
  "Content-Length",
  "Accept",
  "Accept-Encoding",
  "User-Agent",
  "Authorization"
]);
a.reduceDescriptors(D.prototype, ({ value: e }, t) => {
  let n = t[0].toUpperCase() + t.slice(1);
  return {
    get: () => e,
    set(r) {
      this[n] = r;
    }
  };
});
a.freezeMethods(D);
function Oe(e, t) {
  const n = this || re, r = t || n, s = D.from(r.headers);
  let o = r.data;
  return a.forEach(e, function(c) {
    o = c.call(n, o, s.normalize(), t ? t.status : void 0);
  }), s.normalize(), o;
}
function Ot(e) {
  return !!(e && e.__CANCEL__);
}
let se = class extends y {
  /**
   * A `CanceledError` is an object that is thrown when an operation is canceled.
   *
   * @param {string=} message The message.
   * @param {Object=} config The config.
   * @param {Object=} request The request.
   *
   * @returns {CanceledError} The created error.
   */
  constructor(t, n, r) {
    super(t ?? "canceled", y.ERR_CANCELED, n, r), this.name = "CanceledError", this.__CANCEL__ = !0;
  }
};
function Ct(e, t, n) {
  const r = n.config.validateStatus;
  !n.status || !r || r(n.status) ? e(n) : t(
    new y(
      "Request failed with status code " + n.status,
      [y.ERR_BAD_REQUEST, y.ERR_BAD_RESPONSE][Math.floor(n.status / 100) - 4],
      n.config,
      n.request,
      n
    )
  );
}
function er(e) {
  const t = /^([-+\w]{1,25})(:?\/\/|:)/.exec(e);
  return t && t[1] || "";
}
function tr(e, t) {
  e = e || 10;
  const n = new Array(e), r = new Array(e);
  let s = 0, o = 0, i;
  return t = t !== void 0 ? t : 1e3, function(f) {
    const d = Date.now(), l = r[o];
    i || (i = d), n[s] = f, r[s] = d;
    let p = o, b = 0;
    for (; p !== s; )
      b += n[p++], p = p % e;
    if (s = (s + 1) % e, s === o && (o = (o + 1) % e), d - i < t)
      return;
    const R = l && d - l;
    return R ? Math.round(b * 1e3 / R) : void 0;
  };
}
function nr(e, t) {
  let n = 0, r = 1e3 / t, s, o;
  const i = (d, l = Date.now()) => {
    n = l, s = null, o && (clearTimeout(o), o = null), e(...d);
  };
  return [(...d) => {
    const l = Date.now(), p = l - n;
    p >= r ? i(d, l) : (s = d, o || (o = setTimeout(() => {
      o = null, i(s);
    }, r - p)));
  }, () => s && i(s)];
}
const he = (e, t, n = 3) => {
  let r = 0;
  const s = tr(50, 250);
  return nr((o) => {
    const i = o.loaded, c = o.lengthComputable ? o.total : void 0, f = i - r, d = s(f), l = i <= c;
    r = i;
    const p = {
      loaded: i,
      total: c,
      progress: c ? i / c : void 0,
      bytes: f,
      rate: d || void 0,
      estimated: d && c && l ? (c - i) / d : void 0,
      event: o,
      lengthComputable: c != null,
      [t ? "download" : "upload"]: !0
    };
    e(p);
  }, n);
}, Ye = (e, t) => {
  const n = e != null;
  return [
    (r) => t[0]({
      lengthComputable: n,
      total: e,
      loaded: r
    }),
    t[1]
  ];
}, Ze = (e) => (...t) => a.asap(() => e(...t)), rr = _.hasStandardBrowserEnv ? /* @__PURE__ */ ((e, t) => (n) => (n = new URL(n, _.origin), e.protocol === n.protocol && e.host === n.host && (t || e.port === n.port)))(
  new URL(_.origin),
  _.navigator && /(msie|trident)/i.test(_.navigator.userAgent)
) : () => !0, sr = _.hasStandardBrowserEnv ? (
  // Standard browser envs support document.cookie
  {
    write(e, t, n, r, s, o, i) {
      if (typeof document > "u") return;
      const c = [`${e}=${encodeURIComponent(t)}`];
      a.isNumber(n) && c.push(`expires=${new Date(n).toUTCString()}`), a.isString(r) && c.push(`path=${r}`), a.isString(s) && c.push(`domain=${s}`), o === !0 && c.push("secure"), a.isString(i) && c.push(`SameSite=${i}`), document.cookie = c.join("; ");
    },
    read(e) {
      if (typeof document > "u") return null;
      const t = document.cookie.match(new RegExp("(?:^|; )" + e + "=([^;]*)"));
      return t ? decodeURIComponent(t[1]) : null;
    },
    remove(e) {
      this.write(e, "", Date.now() - 864e5, "/");
    }
  }
) : (
  // Non-standard browser env (web workers, react-native) lack needed support.
  {
    write() {
    },
    read() {
      return null;
    },
    remove() {
    }
  }
);
function or(e) {
  return typeof e != "string" ? !1 : /^([a-z][a-z\d+\-.]*:)?\/\//i.test(e);
}
function ir(e, t) {
  return t ? e.replace(/\/?\/$/, "") + "/" + t.replace(/^\/+/, "") : e;
}
function Tt(e, t, n) {
  let r = !or(t);
  return e && (r || n == !1) ? ir(e, t) : t;
}
const et = (e) => e instanceof D ? { ...e } : e;
function K(e, t) {
  t = t || {};
  const n = {};
  function r(d, l, p, b) {
    return a.isPlainObject(d) && a.isPlainObject(l) ? a.merge.call({ caseless: b }, d, l) : a.isPlainObject(l) ? a.merge({}, l) : a.isArray(l) ? l.slice() : l;
  }
  function s(d, l, p, b) {
    if (a.isUndefined(l)) {
      if (!a.isUndefined(d))
        return r(void 0, d, p, b);
    } else return r(d, l, p, b);
  }
  function o(d, l) {
    if (!a.isUndefined(l))
      return r(void 0, l);
  }
  function i(d, l) {
    if (a.isUndefined(l)) {
      if (!a.isUndefined(d))
        return r(void 0, d);
    } else return r(void 0, l);
  }
  function c(d, l, p) {
    if (p in t)
      return r(d, l);
    if (p in e)
      return r(void 0, d);
  }
  const f = {
    url: o,
    method: o,
    data: o,
    baseURL: i,
    transformRequest: i,
    transformResponse: i,
    paramsSerializer: i,
    timeout: i,
    timeoutMessage: i,
    withCredentials: i,
    withXSRFToken: i,
    adapter: i,
    responseType: i,
    xsrfCookieName: i,
    xsrfHeaderName: i,
    onUploadProgress: i,
    onDownloadProgress: i,
    decompress: i,
    maxContentLength: i,
    maxBodyLength: i,
    beforeRedirect: i,
    transport: i,
    httpAgent: i,
    httpsAgent: i,
    cancelToken: i,
    socketPath: i,
    responseEncoding: i,
    validateStatus: c,
    headers: (d, l, p) => s(et(d), et(l), p, !0)
  };
  return a.forEach(Object.keys({ ...e, ...t }), function(l) {
    if (l === "__proto__" || l === "constructor" || l === "prototype") return;
    const p = a.hasOwnProp(f, l) ? f[l] : s, b = p(e[l], t[l], l);
    a.isUndefined(b) && p !== c || (n[l] = b);
  }), n;
}
const _t = (e) => {
  const t = K({}, e);
  let { data: n, withXSRFToken: r, xsrfHeaderName: s, xsrfCookieName: o, headers: i, auth: c } = t;
  if (t.headers = i = D.from(i), t.url = Et(
    Tt(t.baseURL, t.url, t.allowAbsoluteUrls),
    e.params,
    e.paramsSerializer
  ), c && i.set(
    "Authorization",
    "Basic " + btoa(
      (c.username || "") + ":" + (c.password ? unescape(encodeURIComponent(c.password)) : "")
    )
  ), a.isFormData(n)) {
    if (_.hasStandardBrowserEnv || _.hasStandardBrowserWebWorkerEnv)
      i.setContentType(void 0);
    else if (a.isFunction(n.getHeaders)) {
      const f = n.getHeaders(), d = ["content-type", "content-length"];
      Object.entries(f).forEach(([l, p]) => {
        d.includes(l.toLowerCase()) && i.set(l, p);
      });
    }
  }
  if (_.hasStandardBrowserEnv && (r && a.isFunction(r) && (r = r(t)), r || r !== !1 && rr(t.url))) {
    const f = s && o && sr.read(o);
    f && i.set(s, f);
  }
  return t;
}, ar = typeof XMLHttpRequest < "u", cr = ar && function(e) {
  return new Promise(function(n, r) {
    const s = _t(e);
    let o = s.data;
    const i = D.from(s.headers).normalize();
    let { responseType: c, onUploadProgress: f, onDownloadProgress: d } = s, l, p, b, R, u;
    function m() {
      R && R(), u && u(), s.cancelToken && s.cancelToken.unsubscribe(l), s.signal && s.signal.removeEventListener("abort", l);
    }
    let h = new XMLHttpRequest();
    h.open(s.method.toUpperCase(), s.url, !0), h.timeout = s.timeout;
    function w() {
      if (!h)
        return;
      const O = D.from(
        "getAllResponseHeaders" in h && h.getAllResponseHeaders()
      ), F = {
        data: !c || c === "text" || c === "json" ? h.responseText : h.response,
        status: h.status,
        statusText: h.statusText,
        headers: O,
        config: e,
        request: h
      };
      Ct(
        function(L) {
          n(L), m();
        },
        function(L) {
          r(L), m();
        },
        F
      ), h = null;
    }
    "onloadend" in h ? h.onloadend = w : h.onreadystatechange = function() {
      !h || h.readyState !== 4 || h.status === 0 && !(h.responseURL && h.responseURL.indexOf("file:") === 0) || setTimeout(w);
    }, h.onabort = function() {
      h && (r(new y("Request aborted", y.ECONNABORTED, e, h)), h = null);
    }, h.onerror = function(N) {
      const F = N && N.message ? N.message : "Network Error", I = new y(F, y.ERR_NETWORK, e, h);
      I.event = N || null, r(I), h = null;
    }, h.ontimeout = function() {
      let N = s.timeout ? "timeout of " + s.timeout + "ms exceeded" : "timeout exceeded";
      const F = s.transitional || Ue;
      s.timeoutErrorMessage && (N = s.timeoutErrorMessage), r(
        new y(
          N,
          F.clarifyTimeoutError ? y.ETIMEDOUT : y.ECONNABORTED,
          e,
          h
        )
      ), h = null;
    }, o === void 0 && i.setContentType(null), "setRequestHeader" in h && a.forEach(i.toJSON(), function(N, F) {
      h.setRequestHeader(F, N);
    }), a.isUndefined(s.withCredentials) || (h.withCredentials = !!s.withCredentials), c && c !== "json" && (h.responseType = s.responseType), d && ([b, u] = he(d, !0), h.addEventListener("progress", b)), f && h.upload && ([p, R] = he(f), h.upload.addEventListener("progress", p), h.upload.addEventListener("loadend", R)), (s.cancelToken || s.signal) && (l = (O) => {
      h && (r(!O || O.type ? new se(null, e, h) : O), h.abort(), h = null);
    }, s.cancelToken && s.cancelToken.subscribe(l), s.signal && (s.signal.aborted ? l() : s.signal.addEventListener("abort", l)));
    const A = er(s.url);
    if (A && _.protocols.indexOf(A) === -1) {
      r(
        new y(
          "Unsupported protocol " + A + ":",
          y.ERR_BAD_REQUEST,
          e
        )
      );
      return;
    }
    h.send(o || null);
  });
}, lr = (e, t) => {
  const { length: n } = e = e ? e.filter(Boolean) : [];
  if (t || n) {
    let r = new AbortController(), s;
    const o = function(d) {
      if (!s) {
        s = !0, c();
        const l = d instanceof Error ? d : this.reason;
        r.abort(
          l instanceof y ? l : new se(l instanceof Error ? l.message : l)
        );
      }
    };
    let i = t && setTimeout(() => {
      i = null, o(new y(`timeout of ${t}ms exceeded`, y.ETIMEDOUT));
    }, t);
    const c = () => {
      e && (i && clearTimeout(i), i = null, e.forEach((d) => {
        d.unsubscribe ? d.unsubscribe(o) : d.removeEventListener("abort", o);
      }), e = null);
    };
    e.forEach((d) => d.addEventListener("abort", o));
    const { signal: f } = r;
    return f.unsubscribe = () => a.asap(c), f;
  }
}, ur = function* (e, t) {
  let n = e.byteLength;
  if (n < t) {
    yield e;
    return;
  }
  let r = 0, s;
  for (; r < n; )
    s = r + t, yield e.slice(r, s), r = s;
}, dr = async function* (e, t) {
  for await (const n of fr(e))
    yield* ur(n, t);
}, fr = async function* (e) {
  if (e[Symbol.asyncIterator]) {
    yield* e;
    return;
  }
  const t = e.getReader();
  try {
    for (; ; ) {
      const { done: n, value: r } = await t.read();
      if (n)
        break;
      yield r;
    }
  } finally {
    await t.cancel();
  }
}, tt = (e, t, n, r) => {
  const s = dr(e, t);
  let o = 0, i, c = (f) => {
    i || (i = !0, r && r(f));
  };
  return new ReadableStream(
    {
      async pull(f) {
        try {
          const { done: d, value: l } = await s.next();
          if (d) {
            c(), f.close();
            return;
          }
          let p = l.byteLength;
          if (n) {
            let b = o += p;
            n(b);
          }
          f.enqueue(new Uint8Array(l));
        } catch (d) {
          throw c(d), d;
        }
      },
      cancel(f) {
        return c(f), s.return();
      }
    },
    {
      highWaterMark: 2
    }
  );
}, nt = 64 * 1024, { isFunction: le } = a, pr = (({ Request: e, Response: t }) => ({
  Request: e,
  Response: t
}))(a.global), { ReadableStream: rt, TextEncoder: st } = a.global, ot = (e, ...t) => {
  try {
    return !!e(...t);
  } catch {
    return !1;
  }
}, hr = (e) => {
  e = a.merge.call(
    {
      skipUndefined: !0
    },
    pr,
    e
  );
  const { fetch: t, Request: n, Response: r } = e, s = t ? le(t) : typeof fetch == "function", o = le(n), i = le(r);
  if (!s)
    return !1;
  const c = s && le(rt), f = s && (typeof st == "function" ? /* @__PURE__ */ ((u) => (m) => u.encode(m))(new st()) : async (u) => new Uint8Array(await new n(u).arrayBuffer())), d = o && c && ot(() => {
    let u = !1;
    const m = new rt(), h = new n(_.origin, {
      body: m,
      method: "POST",
      get duplex() {
        return u = !0, "half";
      }
    }).headers.has("Content-Type");
    return m.cancel(), u && !h;
  }), l = i && c && ot(() => a.isReadableStream(new r("").body)), p = {
    stream: l && ((u) => u.body)
  };
  s && ["text", "arrayBuffer", "blob", "formData", "stream"].forEach((u) => {
    !p[u] && (p[u] = (m, h) => {
      let w = m && m[u];
      if (w)
        return w.call(m);
      throw new y(
        `Response type '${u}' is not supported`,
        y.ERR_NOT_SUPPORT,
        h
      );
    });
  });
  const b = async (u) => {
    if (u == null)
      return 0;
    if (a.isBlob(u))
      return u.size;
    if (a.isSpecCompliantForm(u))
      return (await new n(_.origin, {
        method: "POST",
        body: u
      }).arrayBuffer()).byteLength;
    if (a.isArrayBufferView(u) || a.isArrayBuffer(u))
      return u.byteLength;
    if (a.isURLSearchParams(u) && (u = u + ""), a.isString(u))
      return (await f(u)).byteLength;
  }, R = async (u, m) => {
    const h = a.toFiniteNumber(u.getContentLength());
    return h ?? b(m);
  };
  return async (u) => {
    let {
      url: m,
      method: h,
      data: w,
      signal: A,
      cancelToken: O,
      timeout: N,
      onDownloadProgress: F,
      onUploadProgress: I,
      responseType: L,
      headers: Re,
      withCredentials: oe = "same-origin",
      fetchOptions: ke
    } = _t(u), $e = t || fetch;
    L = L ? (L + "").toLowerCase() : "text";
    let ie = lr(
      [A, O && O.toAbortSignal()],
      N
    ), G = null;
    const v = ie && ie.unsubscribe && (() => {
      ie.unsubscribe();
    });
    let je;
    try {
      if (I && d && h !== "get" && h !== "head" && (je = await R(Re, w)) !== 0) {
        let j = new n(m, {
          method: "POST",
          body: w,
          duplex: "half"
        }), W;
        if (a.isFormData(w) && (W = j.headers.get("content-type")) && Re.setContentType(W), j.body) {
          const [Ee, ae] = Ye(
            je,
            he(Ze(I))
          );
          w = tt(j.body, nt, Ee, ae);
        }
      }
      a.isString(oe) || (oe = oe ? "include" : "omit");
      const x = o && "credentials" in n.prototype, Me = {
        ...ke,
        signal: ie,
        method: h.toUpperCase(),
        headers: Re.normalize().toJSON(),
        body: w,
        duplex: "half",
        credentials: x ? oe : void 0
      };
      G = o && new n(m, Me);
      let $ = await (o ? $e(G, ke) : $e(m, Me));
      const ze = l && (L === "stream" || L === "response");
      if (l && (F || ze && v)) {
        const j = {};
        ["status", "statusText", "headers"].forEach((Ie) => {
          j[Ie] = $[Ie];
        });
        const W = a.toFiniteNumber($.headers.get("content-length")), [Ee, ae] = F && Ye(
          W,
          he(Ze(F), !0)
        ) || [];
        $ = new r(
          tt($.body, nt, Ee, () => {
            ae && ae(), v && v();
          }),
          j
        );
      }
      L = L || "text";
      let Bt = await p[a.findKey(p, L) || "text"](
        $,
        u
      );
      return !ze && v && v(), await new Promise((j, W) => {
        Ct(j, W, {
          data: Bt,
          headers: D.from($.headers),
          status: $.status,
          statusText: $.statusText,
          config: u,
          request: G
        });
      });
    } catch (x) {
      throw v && v(), x && x.name === "TypeError" && /Load failed|fetch/i.test(x.message) ? Object.assign(
        new y(
          "Network Error",
          y.ERR_NETWORK,
          u,
          G,
          x && x.response
        ),
        {
          cause: x.cause || x
        }
      ) : y.from(x, x && x.code, u, G, x && x.response);
    }
  };
}, mr = /* @__PURE__ */ new Map(), Nt = (e) => {
  let t = e && e.env || {};
  const { fetch: n, Request: r, Response: s } = t, o = [r, s, n];
  let i = o.length, c = i, f, d, l = mr;
  for (; c--; )
    f = o[c], d = l.get(f), d === void 0 && l.set(f, d = c ? /* @__PURE__ */ new Map() : hr(t)), l = d;
  return d;
};
Nt();
const Be = {
  http: Pn,
  xhr: cr,
  fetch: {
    get: Nt
  }
};
a.forEach(Be, (e, t) => {
  if (e) {
    try {
      Object.defineProperty(e, "name", { value: t });
    } catch {
    }
    Object.defineProperty(e, "adapterName", { value: t });
  }
});
const it = (e) => `- ${e}`, yr = (e) => a.isFunction(e) || e === null || e === !1;
function br(e, t) {
  e = a.isArray(e) ? e : [e];
  const { length: n } = e;
  let r, s;
  const o = {};
  for (let i = 0; i < n; i++) {
    r = e[i];
    let c;
    if (s = r, !yr(r) && (s = Be[(c = String(r)).toLowerCase()], s === void 0))
      throw new y(`Unknown adapter '${c}'`);
    if (s && (a.isFunction(s) || (s = s.get(t))))
      break;
    o[c || "#" + i] = s;
  }
  if (!s) {
    const i = Object.entries(o).map(
      ([f, d]) => `adapter ${f} ` + (d === !1 ? "is not supported by the environment" : "is not available in the build")
    );
    let c = n ? i.length > 1 ? `since :
` + i.map(it).join(`
`) : " " + it(i[0]) : "as no adapter specified";
    throw new y(
      "There is no suitable adapter to dispatch the request " + c,
      "ERR_NOT_SUPPORT"
    );
  }
  return s;
}
const xt = {
  /**
   * Resolve an adapter from a list of adapter names or functions.
   * @type {Function}
   */
  getAdapter: br,
  /**
   * Exposes all known adapters
   * @type {Object<string, Function|Object>}
   */
  adapters: Be
};
function Ce(e) {
  if (e.cancelToken && e.cancelToken.throwIfRequested(), e.signal && e.signal.aborted)
    throw new se(null, e);
}
function at(e) {
  return Ce(e), e.headers = D.from(e.headers), e.data = Oe.call(e, e.transformRequest), ["post", "put", "patch"].indexOf(e.method) !== -1 && e.headers.setContentType("application/x-www-form-urlencoded", !1), xt.getAdapter(e.adapter || re.adapter, e)(e).then(
    function(r) {
      return Ce(e), r.data = Oe.call(e, e.transformResponse, r), r.headers = D.from(r.headers), r;
    },
    function(r) {
      return Ot(r) || (Ce(e), r && r.response && (r.response.data = Oe.call(
        e,
        e.transformResponse,
        r.response
      ), r.response.headers = D.from(r.response.headers))), Promise.reject(r);
    }
  );
}
const Pt = "1.15.0", we = {};
["object", "boolean", "number", "function", "string", "symbol"].forEach((e, t) => {
  we[e] = function(r) {
    return typeof r === e || "a" + (t < 1 ? "n " : " ") + e;
  };
});
const ct = {};
we.transitional = function(t, n, r) {
  function s(o, i) {
    return "[Axios v" + Pt + "] Transitional option '" + o + "'" + i + (r ? ". " + r : "");
  }
  return (o, i, c) => {
    if (t === !1)
      throw new y(
        s(i, " has been removed" + (n ? " in " + n : "")),
        y.ERR_DEPRECATED
      );
    return n && !ct[i] && (ct[i] = !0, console.warn(
      s(
        i,
        " has been deprecated since v" + n + " and will be removed in the near future"
      )
    )), t ? t(o, i, c) : !0;
  };
};
we.spelling = function(t) {
  return (n, r) => (console.warn(`${r} is likely a misspelling of ${t}`), !0);
};
function gr(e, t, n) {
  if (typeof e != "object")
    throw new y("options must be an object", y.ERR_BAD_OPTION_VALUE);
  const r = Object.keys(e);
  let s = r.length;
  for (; s-- > 0; ) {
    const o = r[s], i = t[o];
    if (i) {
      const c = e[o], f = c === void 0 || i(c, o, e);
      if (f !== !0)
        throw new y(
          "option " + o + " must be " + f,
          y.ERR_BAD_OPTION_VALUE
        );
      continue;
    }
    if (n !== !0)
      throw new y("Unknown option " + o, y.ERR_BAD_OPTION);
  }
}
const pe = {
  assertOptions: gr,
  validators: we
}, U = pe.validators;
let V = class {
  constructor(t) {
    this.defaults = t || {}, this.interceptors = {
      request: new Qe(),
      response: new Qe()
    };
  }
  /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */
  async request(t, n) {
    try {
      return await this._request(t, n);
    } catch (r) {
      if (r instanceof Error) {
        let s = {};
        Error.captureStackTrace ? Error.captureStackTrace(s) : s = new Error();
        const o = (() => {
          if (!s.stack)
            return "";
          const i = s.stack.indexOf(`
`);
          return i === -1 ? "" : s.stack.slice(i + 1);
        })();
        try {
          if (!r.stack)
            r.stack = o;
          else if (o) {
            const i = o.indexOf(`
`), c = i === -1 ? -1 : o.indexOf(`
`, i + 1), f = c === -1 ? "" : o.slice(c + 1);
            String(r.stack).endsWith(f) || (r.stack += `
` + o);
          }
        } catch {
        }
      }
      throw r;
    }
  }
  _request(t, n) {
    typeof t == "string" ? (n = n || {}, n.url = t) : n = t || {}, n = K(this.defaults, n);
    const { transitional: r, paramsSerializer: s, headers: o } = n;
    r !== void 0 && pe.assertOptions(
      r,
      {
        silentJSONParsing: U.transitional(U.boolean),
        forcedJSONParsing: U.transitional(U.boolean),
        clarifyTimeoutError: U.transitional(U.boolean),
        legacyInterceptorReqResOrdering: U.transitional(U.boolean)
      },
      !1
    ), s != null && (a.isFunction(s) ? n.paramsSerializer = {
      serialize: s
    } : pe.assertOptions(
      s,
      {
        encode: U.function,
        serialize: U.function
      },
      !0
    )), n.allowAbsoluteUrls !== void 0 || (this.defaults.allowAbsoluteUrls !== void 0 ? n.allowAbsoluteUrls = this.defaults.allowAbsoluteUrls : n.allowAbsoluteUrls = !0), pe.assertOptions(
      n,
      {
        baseUrl: U.spelling("baseURL"),
        withXsrfToken: U.spelling("withXSRFToken")
      },
      !0
    ), n.method = (n.method || this.defaults.method || "get").toLowerCase();
    let i = o && a.merge(o.common, o[n.method]);
    o && a.forEach(["delete", "get", "head", "post", "put", "patch", "common"], (u) => {
      delete o[u];
    }), n.headers = D.concat(i, o);
    const c = [];
    let f = !0;
    this.interceptors.request.forEach(function(m) {
      if (typeof m.runWhen == "function" && m.runWhen(n) === !1)
        return;
      f = f && m.synchronous;
      const h = n.transitional || Ue;
      h && h.legacyInterceptorReqResOrdering ? c.unshift(m.fulfilled, m.rejected) : c.push(m.fulfilled, m.rejected);
    });
    const d = [];
    this.interceptors.response.forEach(function(m) {
      d.push(m.fulfilled, m.rejected);
    });
    let l, p = 0, b;
    if (!f) {
      const u = [at.bind(this), void 0];
      for (u.unshift(...c), u.push(...d), b = u.length, l = Promise.resolve(n); p < b; )
        l = l.then(u[p++], u[p++]);
      return l;
    }
    b = c.length;
    let R = n;
    for (; p < b; ) {
      const u = c[p++], m = c[p++];
      try {
        R = u(R);
      } catch (h) {
        m.call(this, h);
        break;
      }
    }
    try {
      l = at.call(this, R);
    } catch (u) {
      return Promise.reject(u);
    }
    for (p = 0, b = d.length; p < b; )
      l = l.then(d[p++], d[p++]);
    return l;
  }
  getUri(t) {
    t = K(this.defaults, t);
    const n = Tt(t.baseURL, t.url, t.allowAbsoluteUrls);
    return Et(n, t.params, t.paramsSerializer);
  }
};
a.forEach(["delete", "get", "head", "options"], function(t) {
  V.prototype[t] = function(n, r) {
    return this.request(
      K(r || {}, {
        method: t,
        url: n,
        data: (r || {}).data
      })
    );
  };
});
a.forEach(["post", "put", "patch"], function(t) {
  function n(r) {
    return function(o, i, c) {
      return this.request(
        K(c || {}, {
          method: t,
          headers: r ? {
            "Content-Type": "multipart/form-data"
          } : {},
          url: o,
          data: i
        })
      );
    };
  }
  V.prototype[t] = n(), V.prototype[t + "Form"] = n(!0);
});
let wr = class Dt {
  constructor(t) {
    if (typeof t != "function")
      throw new TypeError("executor must be a function.");
    let n;
    this.promise = new Promise(function(o) {
      n = o;
    });
    const r = this;
    this.promise.then((s) => {
      if (!r._listeners) return;
      let o = r._listeners.length;
      for (; o-- > 0; )
        r._listeners[o](s);
      r._listeners = null;
    }), this.promise.then = (s) => {
      let o;
      const i = new Promise((c) => {
        r.subscribe(c), o = c;
      }).then(s);
      return i.cancel = function() {
        r.unsubscribe(o);
      }, i;
    }, t(function(o, i, c) {
      r.reason || (r.reason = new se(o, i, c), n(r.reason));
    });
  }
  /**
   * Throws a `CanceledError` if cancellation has been requested.
   */
  throwIfRequested() {
    if (this.reason)
      throw this.reason;
  }
  /**
   * Subscribe to the cancel signal
   */
  subscribe(t) {
    if (this.reason) {
      t(this.reason);
      return;
    }
    this._listeners ? this._listeners.push(t) : this._listeners = [t];
  }
  /**
   * Unsubscribe from the cancel signal
   */
  unsubscribe(t) {
    if (!this._listeners)
      return;
    const n = this._listeners.indexOf(t);
    n !== -1 && this._listeners.splice(n, 1);
  }
  toAbortSignal() {
    const t = new AbortController(), n = (r) => {
      t.abort(r);
    };
    return this.subscribe(n), t.signal.unsubscribe = () => this.unsubscribe(n), t.signal;
  }
  /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */
  static source() {
    let t;
    return {
      token: new Dt(function(s) {
        t = s;
      }),
      cancel: t
    };
  }
};
function Rr(e) {
  return function(n) {
    return e.apply(null, n);
  };
}
function Er(e) {
  return a.isObject(e) && e.isAxiosError === !0;
}
const xe = {
  Continue: 100,
  SwitchingProtocols: 101,
  Processing: 102,
  EarlyHints: 103,
  Ok: 200,
  Created: 201,
  Accepted: 202,
  NonAuthoritativeInformation: 203,
  NoContent: 204,
  ResetContent: 205,
  PartialContent: 206,
  MultiStatus: 207,
  AlreadyReported: 208,
  ImUsed: 226,
  MultipleChoices: 300,
  MovedPermanently: 301,
  Found: 302,
  SeeOther: 303,
  NotModified: 304,
  UseProxy: 305,
  Unused: 306,
  TemporaryRedirect: 307,
  PermanentRedirect: 308,
  BadRequest: 400,
  Unauthorized: 401,
  PaymentRequired: 402,
  Forbidden: 403,
  NotFound: 404,
  MethodNotAllowed: 405,
  NotAcceptable: 406,
  ProxyAuthenticationRequired: 407,
  RequestTimeout: 408,
  Conflict: 409,
  Gone: 410,
  LengthRequired: 411,
  PreconditionFailed: 412,
  PayloadTooLarge: 413,
  UriTooLong: 414,
  UnsupportedMediaType: 415,
  RangeNotSatisfiable: 416,
  ExpectationFailed: 417,
  ImATeapot: 418,
  MisdirectedRequest: 421,
  UnprocessableEntity: 422,
  Locked: 423,
  FailedDependency: 424,
  TooEarly: 425,
  UpgradeRequired: 426,
  PreconditionRequired: 428,
  TooManyRequests: 429,
  RequestHeaderFieldsTooLarge: 431,
  UnavailableForLegalReasons: 451,
  InternalServerError: 500,
  NotImplemented: 501,
  BadGateway: 502,
  ServiceUnavailable: 503,
  GatewayTimeout: 504,
  HttpVersionNotSupported: 505,
  VariantAlsoNegotiates: 506,
  InsufficientStorage: 507,
  LoopDetected: 508,
  NotExtended: 510,
  NetworkAuthenticationRequired: 511,
  WebServerIsDown: 521,
  ConnectionTimedOut: 522,
  OriginIsUnreachable: 523,
  TimeoutOccurred: 524,
  SslHandshakeFailed: 525,
  InvalidSslCertificate: 526
};
Object.entries(xe).forEach(([e, t]) => {
  xe[t] = e;
});
function Lt(e) {
  const t = new V(e), n = ut(V.prototype.request, t);
  return a.extend(n, V.prototype, t, { allOwnKeys: !0 }), a.extend(n, t, null, { allOwnKeys: !0 }), n.create = function(s) {
    return Lt(K(e, s));
  }, n;
}
const S = Lt(re);
S.Axios = V;
S.CanceledError = se;
S.CancelToken = wr;
S.isCancel = Ot;
S.VERSION = Pt;
S.toFormData = ge;
S.AxiosError = y;
S.Cancel = S.CanceledError;
S.all = function(t) {
  return Promise.all(t);
};
S.spread = Rr;
S.isAxiosError = Er;
S.mergeConfig = K;
S.AxiosHeaders = D;
S.formToJSON = (e) => St(a.isHTMLForm(e) ? new FormData(e) : e);
S.getAdapter = xt.getAdapter;
S.HttpStatusCode = xe;
S.default = S;
const {
  Axios: Qr,
  AxiosError: Gr,
  CanceledError: Yr,
  isCancel: Zr,
  CancelToken: es,
  VERSION: ts,
  all: ns,
  Cancel: rs,
  isAxiosError: ss,
  spread: os,
  toFormData: is,
  AxiosHeaders: as,
  HttpStatusCode: cs,
  formToJSON: ls,
  getAdapter: us,
  mergeConfig: ds
} = S;
let Ut = {
  baseUrl: "",
  tenant: ""
};
const Sr = (e) => {
  Ut = e;
}, qe = S.create();
qe.interceptors.request.use((e) => {
  const { baseUrl: t, tenant: n } = Ut;
  return e.baseURL || (e.baseURL = t), e.headers.set("X-Tenant", n), e;
});
qe.interceptors.response.use(
  (e) => e,
  (e) => (S.isAxiosError(e) && e.response, Promise.reject(e))
);
const J = qe, z = {
  CARTS: "checkout-carts",
  CART_DETAIL: "checkout-cart-detail"
}, Ar = ({ customerId: e, cartStatus: t, enabled: n = !0 }) => lt({
  queryKey: [z.CARTS, e, t],
  queryFn: async () => {
    const r = t ? { cartStatus: t } : {};
    return (await J.get("/v1/carts", {
      headers: { "X-Customer-Id": e },
      params: r
    })).data;
  },
  enabled: n && !!e
}), fs = ({ cartId: e, customerId: t, enabled: n = !0 }) => lt({
  queryKey: [z.CART_DETAIL, e, t],
  queryFn: async () => (await J.get(`/v1/carts/${e}`, {
    headers: { "X-Customer-Id": t }
  })).data,
  enabled: n && !!e && !!t
}), ps = ({ customerId: e }) => Z({
  mutationFn: async (t) => (await J.post("/v1/carts", t, {
    headers: { "X-Customer-Id": e }
  })).data
  // No invalidation here — cart is DRAFT at this point.
  // The caller must add items, which transitions the cart to ACTIVE,
  // and then invalidate so CartProvider picks up the active cart.
}), hs = () => {
  const e = Pe();
  return Z({
    mutationFn: async ({ cartId: t, customerId: n, items: r }) => (await J.post(
      `/v1/carts/${t}/items`,
      { items: r },
      {
        headers: { "X-Customer-Id": n }
      }
    )).data,
    onSuccess: (t, { cartId: n, customerId: r }) => {
      e.invalidateQueries({ queryKey: [z.CARTS, r] }), e.invalidateQueries({ queryKey: [z.CART_DETAIL, n] });
    }
  });
}, Or = () => {
  const e = Pe();
  return Z({
    mutationFn: async ({
      cartId: t,
      itemId: n,
      customerId: r,
      quantityOrdered: s
    }) => (await J.patch(
      `/v1/carts/${t}/items/${n}`,
      { quantityOrdered: s },
      { headers: { "X-Customer-Id": r } }
    )).data,
    onSuccess: (t, { cartId: n, customerId: r }) => {
      e.invalidateQueries({ queryKey: [z.CARTS, r] }), e.invalidateQueries({ queryKey: [z.CART_DETAIL, n] });
    }
  });
}, ms = () => Z({
  mutationFn: async ({ cartId: e, itemId: t, customerId: n }) => (await J.delete(`/v1/carts/${e}/items/${t}`, {
    headers: { "X-Customer-Id": n }
  })).data
}), ys = () => {
  const e = Pe();
  return Z({
    mutationFn: async ({ cartId: t, customerId: n }) => (await J.delete(`/v1/carts/${t}`, {
      headers: { "X-Customer-Id": n }
    })).data,
    onSuccess: (t, { cartId: n, customerId: r }) => {
      e.invalidateQueries({ queryKey: [z.CARTS, r] }), e.removeQueries({ queryKey: [z.CART_DETAIL, n] });
    }
  });
}, Cr = {
  cartCount: 0,
  activeCart: null,
  isLoading: !1,
  cartError: null,
  refetchCart: () => {
  }
}, Ft = kt(Cr), bs = ({
  baseUrl: e,
  tenant: t,
  customerId: n,
  children: r
}) => {
  var p, b;
  ve(() => {
    Sr({ baseUrl: e, tenant: t });
  }, [e, t]);
  const { data: s, isLoading: o, error: i, refetch: c } = Ar({
    customerId: n,
    cartStatus: "ACTIVE",
    enabled: !!n
  }), f = ((p = s == null ? void 0 : s.carts) == null ? void 0 : p[0]) ?? null, d = ((b = f == null ? void 0 : f.items) == null ? void 0 : b.length) ?? 0, l = ve(
    () => ({
      cartCount: d,
      activeCart: f,
      isLoading: o,
      cartError: i,
      refetchCart: c
    }),
    [d, f, o, i, c]
  );
  return /* @__PURE__ */ g(Ft.Provider, { value: l, children: r });
}, Tr = () => $t(Ft), _r = 600, gs = ({
  cartId: e,
  itemId: t,
  customerId: n,
  initialQuantity: r,
  min: s = 1,
  max: o
}) => {
  const [i, c] = jt(r), f = He(null), d = He(r), { mutate: l, isPending: p, error: b } = Or();
  Ve(() => {
    c(r), d.current = r;
  }, [r]);
  const R = ce(
    (w) => {
      f.current && clearTimeout(f.current), f.current = setTimeout(() => {
        w !== d.current && (d.current = w, l({ cartId: e, itemId: t, customerId: n, quantityOrdered: w }));
      }, _r);
    },
    [l, e, t, n]
  );
  Ve(() => () => {
    f.current && clearTimeout(f.current);
  }, []);
  const u = ce(() => {
    c((w) => {
      const A = o !== void 0 ? Math.min(w + 1, o) : w + 1;
      return R(A), A;
    });
  }, [o, R]), m = ce(() => {
    c((w) => {
      const A = Math.max(w - 1, s);
      return R(A), A;
    });
  }, [s, R]), h = ce(
    (w) => {
      const A = Math.max(s, o !== void 0 ? Math.min(w, o) : w);
      c(A), R(A);
    },
    [s, o, R]
  );
  return {
    quantity: i,
    increment: u,
    decrement: m,
    setQuantity: h,
    isUpdating: p,
    updateError: b
  };
}, Nr = {
  DRAFT: "Draft",
  ACTIVE: "Active",
  CHECKED_OUT: "Checked Out",
  ABANDONED: "Abandoned",
  DELETED: "Deleted"
}, xr = {
  DRAFT: "neutral",
  ACTIVE: "success",
  CHECKED_OUT: "informative",
  ABANDONED: "warning",
  DELETED: "error"
}, Pr = ({
  dataTestId: e,
  status: t,
  className: n
}) => /* @__PURE__ */ g("span", { "data-testid": e, className: n, children: /* @__PURE__ */ g(Mt, { label: Nr[t], color: xr[t], type: "secondary" }) }), Dr = "_itemInfo_128om_13", Lr = "_quantity_128om_23", Ur = "_unitPrice_128om_28", Fr = "_lineTotal_128om_33", Br = "_row_128om_38", qr = "_quantityControls_128om_45", kr = "_qtyBtn_128om_51", q = {
  itemInfo: Dr,
  quantity: Lr,
  unitPrice: Ur,
  lineTotal: Fr,
  row: Br,
  quantityControls: qr,
  qtyBtn: kr
}, $r = ({
  dataTestId: e,
  item: t,
  currencyCode: n,
  isLast: r = !1,
  quantityControls: s
}) => {
  const o = (s == null ? void 0 : s.quantity) ?? t.quantityOrdered, i = s && o > (s.min ?? 1), c = s && (s.max === void 0 || o < s.max);
  return /* @__PURE__ */ T(C, { "data-testid": e, children: [
    /* @__PURE__ */ T(C, { pt: 12, pb: 12, pl: 16, pr: 16, className: q.row, children: [
      /* @__PURE__ */ T(C, { className: q.itemInfo, children: [
        /* @__PURE__ */ g(E, { variant: "body", size: "small", color: "gray-1", "data-testid": `${e}-name`, children: t.itemName }),
        /* @__PURE__ */ g(E, { variant: "body", size: "small", color: "gray-4", "data-testid": `${e}-code`, children: t.itemCode })
      ] }),
      s ? /* @__PURE__ */ T(C, { className: q.quantityControls, children: [
        /* @__PURE__ */ g(
          "button",
          {
            type: "button",
            onClick: s.decrement,
            disabled: !i || s.isUpdating,
            "aria-label": "Decrease quantity",
            "data-testid": `${e}-qty-decrement`,
            className: q.qtyBtn,
            children: "−"
          }
        ),
        /* @__PURE__ */ g(
          E,
          {
            variant: "body",
            size: "small",
            color: "gray-1",
            className: q.quantity,
            "data-testid": `${e}-qty`,
            children: o
          }
        ),
        /* @__PURE__ */ g(
          "button",
          {
            type: "button",
            onClick: s.increment,
            disabled: !c || s.isUpdating,
            "aria-label": "Increase quantity",
            "data-testid": `${e}-qty-increment`,
            className: q.qtyBtn,
            children: "+"
          }
        )
      ] }) : /* @__PURE__ */ T(
        E,
        {
          variant: "body",
          size: "small",
          color: "gray-2",
          className: q.quantity,
          "data-testid": `${e}-qty`,
          children: [
            "x",
            o
          ]
        }
      ),
      /* @__PURE__ */ g(
        E,
        {
          variant: "body",
          size: "small",
          color: "gray-3",
          className: q.unitPrice,
          "data-testid": `${e}-unit-price`,
          children: M(t.unitPrice, n)
        }
      ),
      /* @__PURE__ */ g(
        E,
        {
          variant: "body",
          size: "small",
          color: "gray-1",
          className: q.lineTotal,
          "data-testid": `${e}-line-total`,
          children: M(t.lineTotalAmount, n)
        }
      )
    ] }),
    !r && /* @__PURE__ */ g(ue, { showLine: !0 })
  ] });
}, jr = "_header_15sx1_7", Mr = "_cartMeta_15sx1_15", zr = "_pricing_15sx1_32", Ir = "_pricingRow_15sx1_40", k = {
  header: jr,
  cartMeta: Mr,
  pricing: zr,
  pricingRow: Ir
}, ws = ({ dataTestId: e, labels: t = {} }) => {
  const { activeCart: n, isLoading: r } = Tr(), {
    emptyState: s = "Your cart is empty",
    subtotal: o = "Subtotal",
    discount: i = "Discount",
    shipping: c = "Shipping",
    fees: f = "Fees",
    tax: d = "Tax",
    grandTotal: l = "Grand Total"
  } = t;
  if (r)
    return /* @__PURE__ */ g(C, { "data-testid": e, pt: 24, pb: 24, pl: 16, pr: 16, children: /* @__PURE__ */ g(
      E,
      {
        variant: "body",
        size: "small",
        color: "gray-4",
        "data-testid": `${e}-loading`,
        children: "Loading..."
      }
    ) });
  if (!n)
    return /* @__PURE__ */ g(C, { "data-testid": e, pt: 24, pb: 24, pl: 16, pr: 16, children: /* @__PURE__ */ g(E, { variant: "body", size: "small", color: "gray-4", "data-testid": `${e}-empty`, children: s }) });
  const p = n.pricingSummary, b = n.currencyCode ?? (p == null ? void 0 : p.currencyCode);
  return /* @__PURE__ */ T(C, { "data-testid": e, children: [
    /* @__PURE__ */ T(C, { pt: 16, pb: 16, pl: 16, pr: 16, className: k.header, children: [
      /* @__PURE__ */ T(C, { className: k.cartMeta, children: [
        /* @__PURE__ */ g(
          E,
          {
            variant: "body",
            size: "medium",
            color: "gray-1",
            "data-testid": `${e}-name`,
            children: n.cartName ?? "Cart"
          }
        ),
        n.cartStatus && /* @__PURE__ */ g(Pr, { dataTestId: `${e}-status`, status: n.cartStatus })
      ] }),
      /* @__PURE__ */ T(
        E,
        {
          variant: "body",
          size: "small",
          color: "gray-4",
          "data-testid": `${e}-item-count`,
          children: [
            n.lineItemCount ?? 0,
            " item",
            n.lineItemCount !== 1 ? "s" : ""
          ]
        }
      )
    ] }),
    /* @__PURE__ */ g(ue, { showLine: !0 }),
    /* @__PURE__ */ g(C, { children: !n.items || n.items.length === 0 ? /* @__PURE__ */ g(C, { pt: 24, pb: 24, pl: 16, pr: 16, children: /* @__PURE__ */ g(
      E,
      {
        variant: "body",
        size: "small",
        color: "gray-4",
        "data-testid": `${e}-empty`,
        children: s
      }
    ) }) : n.items.map((R, u) => {
      var m;
      return /* @__PURE__ */ g(
        $r,
        {
          dataTestId: `${e}-item-${u}`,
          item: R,
          currencyCode: b,
          isLast: u === (((m = n.items) == null ? void 0 : m.length) ?? 0) - 1
        },
        R.itemId ?? u
      );
    }) }),
    p && /* @__PURE__ */ T(qt, { children: [
      /* @__PURE__ */ g(ue, { showLine: !0 }),
      /* @__PURE__ */ T(C, { pt: 16, pb: 16, pl: 16, pr: 16, className: k.pricing, children: [
        /* @__PURE__ */ T(C, { className: k.pricingRow, children: [
          /* @__PURE__ */ g(
            E,
            {
              variant: "body",
              size: "small",
              color: "gray-4",
              "data-testid": `${e}-subtotal-label`,
              children: o
            }
          ),
          /* @__PURE__ */ g(
            E,
            {
              variant: "body",
              size: "small",
              color: "gray-1",
              "data-testid": `${e}-subtotal`,
              children: M(p.subtotal, b)
            }
          )
        ] }),
        p.discountTotal > 0 && /* @__PURE__ */ T(C, { className: k.pricingRow, children: [
          /* @__PURE__ */ g(
            E,
            {
              variant: "body",
              size: "small",
              color: "gray-4",
              "data-testid": `${e}-discount-label`,
              children: i
            }
          ),
          /* @__PURE__ */ T(
            E,
            {
              variant: "body",
              size: "small",
              color: "gray-1",
              "data-testid": `${e}-discount`,
              children: [
                "-",
                M(p.discountTotal, b)
              ]
            }
          )
        ] }),
        p.shippingTotal > 0 && /* @__PURE__ */ T(C, { className: k.pricingRow, children: [
          /* @__PURE__ */ g(
            E,
            {
              variant: "body",
              size: "small",
              color: "gray-4",
              "data-testid": `${e}-shipping-label`,
              children: c
            }
          ),
          /* @__PURE__ */ g(
            E,
            {
              variant: "body",
              size: "small",
              color: "gray-1",
              "data-testid": `${e}-shipping`,
              children: M(p.shippingTotal, b)
            }
          )
        ] }),
        p.feeTotal > 0 && /* @__PURE__ */ T(C, { className: k.pricingRow, children: [
          /* @__PURE__ */ g(
            E,
            {
              variant: "body",
              size: "small",
              color: "gray-4",
              "data-testid": `${e}-fees-label`,
              children: f
            }
          ),
          /* @__PURE__ */ g(
            E,
            {
              variant: "body",
              size: "small",
              color: "gray-1",
              "data-testid": `${e}-fees`,
              children: M(p.feeTotal, b)
            }
          )
        ] }),
        p.taxTotal > 0 && /* @__PURE__ */ T(C, { className: k.pricingRow, children: [
          /* @__PURE__ */ g(
            E,
            {
              variant: "body",
              size: "small",
              color: "gray-4",
              "data-testid": `${e}-tax-label`,
              children: d
            }
          ),
          /* @__PURE__ */ g(
            E,
            {
              variant: "body",
              size: "small",
              color: "gray-1",
              "data-testid": `${e}-tax`,
              children: M(p.taxTotal, b)
            }
          )
        ] }),
        /* @__PURE__ */ g(ue, { showLine: !0 }),
        /* @__PURE__ */ T(C, { className: k.pricingRow, children: [
          /* @__PURE__ */ g(
            E,
            {
              variant: "body",
              size: "medium",
              color: "gray-1",
              "data-testid": `${e}-grand-total-label`,
              children: l
            }
          ),
          /* @__PURE__ */ g(
            E,
            {
              variant: "body",
              size: "medium",
              color: "gray-1",
              "data-testid": `${e}-grand-total`,
              children: M(p.grandTotal, b)
            }
          )
        ] })
      ] })
    ] })
  ] });
};
export {
  J as CartApi,
  $r as CartItemRow,
  bs as CartProvider,
  Pr as CartStatusBadge,
  ws as CartSummary,
  Sr as configureCartApi,
  hs as useAddItemsToCart,
  Tr as useCartContext,
  ps as useCreateCart,
  ys as useDeleteCart,
  ms as useDeleteCartItem,
  fs as useGetCartById,
  Ar as useGetCarts,
  gs as useQuantityControl,
  Or as useUpdateCartItem
};
//# sourceMappingURL=index.mjs.map
